import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  languageLoading: false,
  language: 'Arabic',
  fontsize: 'medium',
  authContent: null,
  dashboardContent: null,
  settingContent: null,
  investmentContent: null,
  fundsContent: null,
  reportsContent: null,
  transferContent: null,
  tradingContent: null,
  helpContent: null,
  corporate: null,
};

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setLanguageLoading: (state, action) => {
      state.languageLoading = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload.language;
    },
    setFontsize: (state, action) => {
      state.fontsize = action.payload;
    },
    setContent: (state, action) => {
      state.appContent = action.payload.appContent;
      state.commonContent = action.payload.commonContent;
      state.authContent = action.payload.authContent;
      state.individualContent = action.payload.individualContent;
      state.dashboardContent = action.payload.dashboardContent;
      state.settingContent = action.payload.settingContent;
      state.investmentContent = action.payload.investmentContent;
      state.fundsContent = action.payload.fundsContent;
      state.reportsContent = action.payload.reportsContent;
      state.transferContent = action.payload.transferContent;
      state.tradingContent = action.payload.tradingContent;
      state.helpContent = action.payload.helpContent;
    },
    setCorporateContent: (state, action) => {
      state.corporate = action.payload;
    },
  },
});

export const { setLanguage, setContent, setFontsize, setLanguageLoading, setCorporateContent } = contentSlice.actions;
export default contentSlice.reducer;
